/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState} from 'react'
import {ParamsModelProizvodnja, ProizvodnjaModel} from '../../models/ProizvodnjaModel'
import {PaginationModel} from '../../models/PaginationModel'
import {
    SortingState,
    createColumnHelper,
    flexRender,
    getCoreRowModel,
    getFilteredRowModel,
    getSortedRowModel,
    useReactTable,
} from '@tanstack/react-table'
import {
    deleteProizvodnja,
    dnevniIzvjestajOtprema,
    getProizvodnja,
    sedmicniIzvjestajUposlenika
} from '../../api/proizvodnja'
import notifyToast from '../../components/Toast/Toast'
import {Link, useNavigate} from 'react-router-dom'
import {KTCard, KTCardBody, KTIcon} from '../../../_websoft/helpers'
import {ToastContainer} from 'react-toastify'
import ExportButton from '../../components/TableExportToExcel/ExportButton'
import LoadingComponent from '../../components/LoadingComponent/LoadingComponent'
import TablePagination from '../../components/TablePagination/TablePagination'
import {TableActionButton} from '../../components/TableActionBtn/TableActionButton'
import IndeterminateCheckbox from '../../components/IndeterminateCheckbox/IndeterminateCheckbox'
import moments from 'moment'
import PakModal from '../../components/PakModal/PakModal'
import DimenzijeModal from '../../components/DimenzijeModal/DimenzijeModal'
import ProizodnjaFilteri from './components/ProizodnjaFilteri/ProizodnjaFilteri'
import ProizodnjaIzmjena from './components/ProizodnjaIzmjena/ProizodnjaIzmjena'
import {Modal, ModalHeader} from 'react-bootstrap'
import KreirajPaketeModal from './components/KreirajPaketeModal/KreirajPaketeModal'
import moment from 'moment'
import RealizacijaReport from "./components/RealizacijaReport";
import RolnePreview from './components/RolnePreview'
import {getOtpremaArea, getOtpremaCijena} from './proizvodnjaTotals'
import {useAuth} from '../../modules/auth'
import {canViewPanelPrice} from './panelPriceAccess'
import RefreshPanelPrices from './components/RefreshPanelPrices'
import './Proizodnja.css'
const Proizodnja = () => {
    const {auth, currentUser} = useAuth()
    const canViewCijena = canViewPanelPrice(auth?.UposlenikId ?? currentUser?.UposlenikId)
    const [data, setData] = useState<ProizvodnjaModel[]>([])
    const [loading, setLoading] = useState(true)
    const [pagination, setpagination] = useState<PaginationModel>({
        curPage: 1,
        totalPage: 1,
        perPage: 10,
    })
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [stavkaId, setstavkaId] = useState<number>()
    const [isModalOpen, setisModalOpen] = useState(false)
    const [isDimenzijeModalOpen, setisDimenzijeModalOpen] = useState(false)
    const [params, setparams] = useState<ParamsModelProizvodnja>({per_page: 10, page: 1})
    const [isSumaOpen, setisSumaOpen] = useState(false)
    const [isRealizacijaOpen, setisRealizacijaOpen] = useState(false)
    const [suma, setSuma] = useState(0)
    const [kolicina, setKolicina] = useState(0)
    const [otpremiti, setOtpremiti] = useState(0)
    const [cijena, setCijena] = useState(0)
    const [isKreirajPaketeOpen, setisKreirajPaketeOpen] = useState(false)

    const [sorting, setSorting] = useState<SortingState>([])
    const [globalFilter, setGlobalFilter] = React.useState('')
    const [rowSelection, setRowSelection] = useState({})

    const [zavrseniNalozi, setzavrseniNalozi] = useState(0)
    const [otvoreniNalozi, setotvoreniNalozi] = useState(0)
    const [isporucenoZadnjaSedmica, setisporucenoZadnjaSedmica] = useState(0)
    const [isporuceno, setisporuceno] = useState(0)
    const [korisnik, setkorisnik] = useState(0)

    const formatter = new Intl.NumberFormat('bs-BA', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

    // Set cell color according to condtions.
    const getCellColor = (cell, row) => {
        if (cell.column.id === 'Status') {
            const status = row.original.statusPro

            if (status === 'Planirano') return '#FFFF00'
            if (status === 'U proizvodnji') return '#FF7F7F'
            if (status === 'Zavrseno') return '#008000'

            return '#FFFFFF' // fallback
        }

        return '#FFFFFF'
    }

    const onPakClick = (id) => {
        setisModalOpen(true)
        setstavkaId(id)
    }
    const onDimenzijeClick = (id) => {
        setisDimenzijeModalOpen(true)
        setstavkaId(id)
    }

    // Suma.
    const handleKolicina = () => {
        let suma = 0; // Ukupna količina ("Kolcina")
        let otpremiti = 0; // Ukupna površina ("Za otpremu")
        let cijena = 0;

        // Koristi filtrirane redove umjesto svih
        table.getFilteredRowModel().rows.forEach((row) => {
            // "Kolcina"
            const cur_val = row
                .getVisibleCells()
                .find((cell) => cell.column.id === 'Kolcina')
                ?.getValue();

            suma += parseFloat(String(cur_val || '0'));

            // "Za otpremu" — računa se iz panel_pakovanja2
            otpremiti += getOtpremaArea(row.original);
            cijena += getOtpremaCijena(row.original);
        });

        setSuma(suma);
        setOtpremiti(otpremiti);
        setCijena(cijena);
    };

    const updatePage = () => {
        setLoading(true)
        getProizvodnja(params)
            .then((response) => {
                const data = response.data['data']
                setData(data)
                const totalPage = Math.floor(response.data['total'] / response.data['per_page'] + 1)
                setpagination({
                    curPage: response.data['current_page'],
                    totalPage: totalPage,
                    perPage: params.per_page,
                })
            })
            .catch((error) => {
                console.error('Error: ', error)
                notifyToast(false, error)
            })
            .finally(() => {
                setLoading(false)
                setRowSelection({})
            })
    }

    useEffect(() => {
        updatePage()
    }, [params])

    useEffect(() => {
        const {id} = sorting[0] ?? ''
        data.sort((a, b) => a[id] - b[id])
    }, [sorting])

    const onFilter = async (filter: Partial<ParamsModelProizvodnja>) => {
        setparams({
            ...filter, // ✅ correct
            per_page: pagination.perPage,
            page: 1,
        })

        if (filter.kreiraoKorisnik) {
            setkorisnik(filter.kreiraoKorisnik)

            try {
                const response = await sedmicniIzvjestajUposlenika({
                    uposlenik: filter.kreiraoKorisnik,
                })

                if (response) {
                    setzavrseniNalozi(response.data.zavrseniNalozi || 0)
                    setotvoreniNalozi(response.data.otvoreniNalozi || 0)
                    setisporuceno(response.data.isporuceno || 0)
                    setisporucenoZadnjaSedmica(response.data.isporucenoZadnjaSedmica || 0)
                }
            } catch (error) {
                console.error('Error fetching data:', error)
            }
        }
    }

    const columnHelper = createColumnHelper<ProizvodnjaModel>()
    const columns = [
        {
            id: 'id',
            header: ({table}) => (
                <div className='row p-2'>
                    <IndeterminateCheckbox
                        {...{
                            checked: table.getIsAllRowsSelected(),
                            indeterminate: table.getIsSomeRowsSelected(),
                            onChange: table.getToggleAllRowsSelectedHandler(),
                        }}
                    />
                </div>
            ),
            cell: ({row, getValue}) => (
                <div className='col'>
                    <IndeterminateCheckbox
                        {...{
                            checked: row.getIsSelected(),
                            indeterminate: row.getIsSomeSelected(),
                            onChange: row.getToggleSelectedHandler(),
                        }}
                    />
                </div>
            ),
        },
        {
            id: 'Nalog',
            header: 'Nalog',
            accessorFn: (row) => `${row.brojNaloga} ${row.brojPonude}`,
            cell: ({row}) => (
                <div>
                    <div>
                        N:{row.original.brojNaloga}({row.original.stavka})
                    </div>
                    <div>
                        Vr.n:
                        <KTIcon
                            iconName={row.original.nalogVracen === 0 ? 'cross' : 'check'}
                            className={row.original.nalogVracen === 0 ? 'text-danger fs-2' : 'text-success fs-2'}
                        />
                    </div>
                    <div>P:{row.original.brojPonude}</div>
                </div>
            ),
        },
        {
            id: 'Artikal',
            header: 'Artikal',
            accessorKey: 'artikal',
        },
        {
            id: 'Kupac',
            header: 'Kupac/kreirao/ Krajnji kupac.',
            accessorFn: (row) => `${row.kupac} ${row.kreiraoKorisnik} ${row.krajnjiKupac}`,
            cell: ({row}) => (
                <div>
                    {row.original.kupac}
                    <div style={{color: 'red'}}>({row.original.kreiraoKorisnik})</div>
                    <div style={{color: 'blue'}}>{row.original.krajnjiKupac}</div>
                </div>
            ),
        },
        {
            id: 'Panel',
            header: 'Panel',
            accessorKey: 'tip_panela.Naziv',
        },
        {
            id: 'izolacija',
            header: 'Izolacija',
            accessorKey: 'izolacija_panela.naziv',
        },
        columnHelper.group({
            header: 'Gornji lim (lice)',
            // footer: props => props.column.id,
            columns: [
                columnHelper.accessor('obloga_gore.naziv', {
                    id: 'obloga_gore',
                    cell: (info) => info.getValue(),
                    header: () => <span>Obloga</span>,
                }),
                columnHelper.accessor('debljina_gore.debljina', {
                    id: 'debljina_gore',
                    cell: (info) => info.getValue(),
                    header: () => <span>Debljina</span>,
                }),
                columnHelper.accessor('boja_gore.BojaNaziv', {
                    id: 'boja_gore',
                    cell: (props) => (
                        <div>
                            <span>{props.getValue()}</span>
                            <RolnePreview key={props.row.original.id} rolne={props.row.original.rolneG} />
                        </div>
                    ),
                    header: () => <span>Boja</span>,
                }),
                columnHelper.accessor('folijaG', {
                    id: 'folijaG',
                    cell: (info) => info.getValue() === '1' ? 'Da' : 'Ne',
                    header: () => <span>Folija</span>,
                }),
            ],
        }),
        columnHelper.group({
            header: 'Donji lim (nalicje)',
            // footer: props => props.column.id,
            columns: [
                columnHelper.accessor('obloga_dole.naziv', {
                    id: 'obloga_dole',
                    cell: (info) => info.getValue(),
                    header: () => <span>Obloga</span>,
                }),
                columnHelper.accessor('debljina_dole.debljina', {
                    id: 'debljina_dole',
                    cell: (info) => info.getValue(),
                    header: () => <span>Debljina</span>,
                }),
                columnHelper.accessor('boja_dole.BojaNaziv', {
                    id: 'boja_dole',
                    cell: (props) => (
                        <div>
                            <span>{props.getValue()}</span>
                            <RolnePreview key={props.row.original.id} rolne={props.row.original.rolneD} />
                        </div>
                    ),
                    header: () => <span>Boja</span>,
                }),
                columnHelper.accessor('folijaD', {
                    id: 'folijaD',
                    cell: (info) => info.getValue() === '1' ? 'Da' : 'Ne',
                    header: () => <span>Folija</span>,
                }),
            ],
        }),
        {
            id: 'Kolcina',
            header: 'Količina [m2]',
            accessorKey: 'kolicina',
            cell: ({row}) => (
                <div>
                    {row.original.kolicina}
                    {row.original.kolicina !== row.original.kolicinaPaketa && (
                        <div className='text-danger'>Upozorenje</div>
                    )}
                </div>
            ),
        },
        {
            id: 'Otprema',
            header: 'Za otpremu [m2]',
            accessorFn: getOtpremaArea,
            cell: ({row}) => {
                const data = row.original.panel_pakovanja2; // Assuming this is your array of objects
                if (!data) return 'N/A';

                // Calculate total area for this row
                const totalArea = getOtpremaArea(row.original);

                return (
                    <div>
                        {totalArea.toFixed(2)} m²
                        {row.original.kolicina !== row.original.kolicinaPaketa && (
                            <div className='text-danger'>Upozorenje</div>
                        )}
                    </div>
                );
            },
        },
        {
            id: 'Cijena',
            header: 'Cijena (m2)',
            accessorFn: getOtpremaCijena,
            cell: ({getValue}) => <span className='text-nowrap'>{formatter.format(getValue())}</span>,
        },
        {
            id: 'Brtvena',
            header: 'Brtvena traka',
            accessorKey: 'brtvenaTraka',
            cell: ({row}: { row: any }) =>
                row.original.brtvenaTraka === '1' ? "Da" : "Ne"
        },
        {
            id: 'Status',
            header: 'Status - Proizvodnje',
            accessorFn: (row) => `${row.statusPro} | ${moments(row.statusProDatum).format('DD-MM-YYYY')}`,
        },
        {
            id: 'isporuka',
            header: 'Isporuka',
            accessorFn: (row) => `${moments(row.isporukaFMK).format('DD-MM-YYYY')}`,
        },
        {
            id: 'pak',
            header: 'Pak',
            cell: ({row}) => (
                <button
                    className='btn btn-primary'
                    onClick={() => {
                        onPakClick(row.original.id)
                    }}
                >
                    Pak
                </button>
            ),
        },
        {
            id: 'Dim',
            header: 'Dim',
            cell: ({row}) => (
                <button
                    className='btn btn-primary'
                    onClick={() => {
                        onDimenzijeClick(row.original.id)
                    }}
                >
                    Dim
                </button>
            ),
        },
        {
            id: 'StatusDays',
            header: 'Dani (Status)',
            accessorFn: (row) => {
                if (!row.statusProDatum) return null

                const today = moment()
                const date = moment(row.statusProDatum)

                return today.diff(date, 'days')
            },
            cell: ({ getValue }) => {
                const days = getValue() as number | null

                if (days === null || days === undefined) return null

                let bgColor = '#008000'
                let textColor = '#fff'

                if (days >= 16 && days <= 30) {
                    bgColor = '#ffff00'
                    textColor = '#000000'
                }

                if (days > 30) {
                    bgColor = '#ef4444'
                    textColor = '#ffffff'
                }

                return (
                    <div
                        style={{
                            backgroundColor: bgColor,
                            color: textColor,
                            fontSize:'20px',
                            padding: '6px 10px',
                            borderRadius: '6px',
                            textAlign: 'center',
                            fontWeight: 600
                        }}
                    >
                        {days}
                    </div>
                )
            }
        },
        {
            header: 'Akcija',
            accessorKey: 'Akcija',
            cell: ({row}) => (
                <TableActionButton
                    onDelete={() => onDelete(row.original.id)}
                    onEdit={() => {
                        onEdit(row.original.id)
                    }}
                />
            ),
        },
    ]
    const table = useReactTable({
        data: data,
        columns: columns.filter((column) => column.id !== 'Cijena' || canViewCijena),
        getCoreRowModel: getCoreRowModel(),
        getSortedRowModel: getSortedRowModel(),
        state: {
            sorting: sorting,
            globalFilter: globalFilter,
            rowSelection: rowSelection,
        },
        onGlobalFilterChange: setGlobalFilter,
        getFilteredRowModel: getFilteredRowModel(),
        onSortingChange: setSorting,
        onRowSelectionChange: setRowSelection,
        enableRowSelection: true,
    })
    const onDelete = (id) => {
        deleteProizvodnja(id)
            .then((response) => {
                notifyToast(true, response)
                setparams({
                    ...params, // ✅ use params here
                    per_page: pagination.perPage,
                    page: pagination.curPage,
                })
            })
            .catch((error) => {
                notifyToast(false, error.data['message'])
            })
    }
    const navigate = useNavigate()

    const onEdit = (rowData) => {
        navigate(`/paneli/izmjena/${rowData}`)
    }

    return (
        <KTCard>
            <ToastContainer/>
            <PakModal isModalOpen={isModalOpen} setisModalOpen={setisModalOpen} stavkaId={stavkaId}/>
            <DimenzijeModal
                isModalOpen={isDimenzijeModalOpen}
                setisModalOpen={setisDimenzijeModalOpen}
                stavkaId={stavkaId}
            />
            <KreirajPaketeModal
                isModalOpen={isKreirajPaketeOpen}
                setisModalOpen={setisKreirajPaketeOpen}
                idProizvodnje={table.getSelectedRowModel().rows}
            />
            <Modal show={isSumaOpen} onHide={() => setisSumaOpen(false)} size="lg">
                <ModalHeader closeButton={true} className='h3'>
                    <h3>Suma</h3>
                </ModalHeader>
                <div className="row p-5">
                    <h3 className="mb-5">Količina: {formatter.format(suma)} m²</h3>
                    <div className='separator'></div>
                    <h3 className="mt-5">Za otpremiti: {formatter.format(otpremiti)} m²</h3>
                    {canViewCijena && <>
                        <div className='separator mt-5'></div>
                        <h3 className="mt-5">Cijena: {formatter.format(cijena)}</h3>
                    </>}
                </div>
            </Modal>
            <Modal
                show={isRealizacijaOpen}
                onHide={() => setisRealizacijaOpen(false)}
                size="xl"
                fullscreen="md-down"
                scrollable
                centered
                aria-labelledby='realizacija-title'
            >
                <Modal.Header closeButton className="border-bottom px-5 px-lg-7 py-5">
                    <div>
                        <div className='text-primary fw-semibold fs-7 mb-1'>Paneli · Realizacija</div>
                        <h2 id='realizacija-title' className="fw-bold mb-1">Stanje lagera i realizacija</h2>
                        <div className="text-muted fs-7">{korisnik ? `Korisnik: ${korisnik}` : 'Pregled prema filterima liste'}</div>
                    </div>
                </Modal.Header>

                <Modal.Body className="p-5 p-lg-7 bg-light">
                    <RealizacijaReport
                        korisnik={korisnik}
                        suma={suma}
                        otpremiti={otpremiti}
                        cijena={cijena}
                        canViewCijena={canViewCijena}
                        zavrseniNalozi={zavrseniNalozi}
                        isporucenoZadnjaSedmica={isporucenoZadnjaSedmica}
                    />
                </Modal.Body>

                <Modal.Footer className="border-top px-5 px-lg-7 py-4">
                    <button className="btn btn-light" onClick={() => setisRealizacijaOpen(false)}>
                        Zatvori
                    </button>
                </Modal.Footer>
            </Modal>
            <KTCardBody className='py-4'>
                <div className='col'>
                    <ProizodnjaIzmjena
                        rowSelection={table.getSelectedRowModel().rows}
                        updatePage={() => updatePage()}
                    />
                    <ProizodnjaFilteri onFilter={onFilter}/>
                </div>
                <div className='panel-shortcuts'>
                    <Link to='kupci-pregled' className='panel-shortcut'>
                        <span className='panel-shortcut-icon'><i className='bi bi-people fs-2'/></span>
                        <span><span className='d-block fw-bold'>Kupci pregled</span><span className='d-block fs-8 text-muted'>Pregled naloga po kupcima</span></span>
                        <i className='bi bi-chevron-right ms-auto'/>
                    </Link>
                    <Link to='/paneli/pregled-paketa' className='panel-shortcut'>
                        <span className='panel-shortcut-icon'><i className='bi bi-box-seam fs-2'/></span>
                        <span><span className='d-block fw-bold'>Pregled paketa</span><span className='d-block fs-8 text-muted'>Paketi i stanje otpreme</span></span>
                        <i className='bi bi-chevron-right ms-auto'/>
                    </Link>
                    {canViewCijena && <RefreshPanelPrices onUpdated={updatePage}/>}
                </div>
                <div className='panel-list-toolbar'>
                    <div className='panel-list-search position-relative'>
                        <label htmlFor='panel-list-search' className='visually-hidden'>Traži naloge</label>
                        <i className='bi bi-search position-absolute top-50 translate-middle-y ms-4 text-muted'/>
                        <input id='panel-list-search' type='search' className='form-control form-control-solid ps-12'
                               placeholder='Traži naloge…' value={globalFilter}
                               onChange={(event) => setGlobalFilter(event.target.value)}/>
                    </div>
                    <div className='panel-list-actions' role='group' aria-label='Akcije liste'>
                        <button
                            className='btn btn-light-success me-3'
                            onClick={() => {
                                setisKreirajPaketeOpen(true)
                            }}
                            disabled={!table.getSelectedRowModel().rows.length}
                        >
                            <KTIcon iconName='truck' className='fs-2'/>
                            Kreiraj paket
                        </button>
                        <button
                            className='btn btn-light-danger me-3'
                            onClick={() => {
                                handleKolicina()
                                setisRealizacijaOpen(true)
                            }}
                        >
                            <KTIcon iconName='calculator' className='fs-2'/>
                            Realizacija
                        </button>
                        <button
                            className='btn btn-light-primary me-3'
                            onClick={() => {
                                handleKolicina()
                                setisSumaOpen(true)
                            }}
                        >
                            <KTIcon iconName='calculator' className='fs-2'/>
                            Suma
                        </button>
                        <ExportButton table={table} filename={'proizvodnja'}/>
                    </div>
                </div>
                {loading ? (
                    <LoadingComponent/>
                ) : (
                    <div className='table-responsive mt-3 '>
                        <table className='table align-middle table-bordered gy-5 no-footer' style={{fontSize: '11px'}}>
                            <thead>
                            {table.getHeaderGroups().map((headerGroup) => (
                                <tr
                                    key={headerGroup.id}
                                    className='text-start fw-bolder fs-7 text-uppercase gs-0 bg-dark p-2'>
                                    {headerGroup.headers.map((header) => (
                                        <th
                                            className='text-white'
                                            key={header.id}
                                            colSpan={header.colSpan}
                                            onClick={header.column.getToggleSortingHandler()}
                                        >
                                            {header.isPlaceholder ? null : (
                                                <span>
                            {flexRender(header.column.columnDef.header, header.getContext())}
                                                    {/* @ts-ignore */}
                                                    {{asc: '🔼', desc: '🔽'}[header.column.getIsSorted() ?? null]}
                          </span>
                                            )}
                                        </th>
                                    ))}
                                </tr>
                            ))}
                            </thead>
                            <tbody className='text-gray-600'>
                            {table.getRowModel().rows && table.getRowModel().rows.length > 0 ? (
                                table.getRowModel().rows.map((row) => (
                                    <tr key={row.id}>
                                        {row.getVisibleCells().map((cell) => (
                                            <td key={cell.id} style={{backgroundColor: getCellColor(cell, row)}}>
                                                {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                            </td>
                                        ))}
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={7}>
                                        <div
                                            className='d-flex text-center w-100 align-content-center justify-content-center'>
                                            No matching records found
                                        </div>
                                    </td>
                                </tr>
                            )}
                            </tbody>
                        </table>
                    </div>
                )}
                <TablePagination
                    updatePage={(page, per_page) => setparams({...params, page: page, per_page: per_page})}
                    pagination={pagination}
                />
            </KTCardBody>
        </KTCard>
    )
}

export default Proizodnja
